/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ActionsRouteImport } from './routes/actions'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ConnectionsRouteImport } from './routes/connections'
import { Route as GoalsRouteImport } from './routes/goals'
import { Route as ImpactRouteImport } from './routes/impact'
import { Route as ManagementRouteImport } from './routes/management'
import { Route as OneOnOnesRouteImport } from './routes/one-on-ones'
import { Route as OrganisationRouteImport } from './routes/organisation'
import { Route as PeopleRouteImport } from './routes/people'
import { Route as PerformanceRouteImport } from './routes/performance'
import { Route as ReportRouteImport } from './routes/report'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as TeamRouteImport } from './routes/team'
import { Route as WorkRouteImport } from './routes/work'
import { Route as WorkforceRouteImport } from './routes/workforce'
import { Route as AdminTenantIdRouteImport } from './routes/admin_.$tenantId'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActionsRoute = ActionsRouteImport.update({
  id: '/actions',
  path: '/actions',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectionsRoute = ConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => rootRouteImport,
} as any)
const GoalsRoute = GoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpactRoute = ImpactRouteImport.update({
  id: '/impact',
  path: '/impact',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagementRoute = ManagementRouteImport.update({
  id: '/management',
  path: '/management',
  getParentRoute: () => rootRouteImport,
} as any)
const OneOnOnesRoute = OneOnOnesRouteImport.update({
  id: '/one-on-ones',
  path: '/one-on-ones',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationRoute = OrganisationRouteImport.update({
  id: '/organisation',
  path: '/organisation',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleRoute = PeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => rootRouteImport,
} as any)
const PerformanceRoute = PerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportRoute = ReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkRoute = WorkRouteImport.update({
  id: '/work',
  path: '/work',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkforceRoute = WorkforceRouteImport.update({
  id: '/workforce',
  path: '/workforce',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTenantIdRoute = AdminTenantIdRouteImport.update({
  id: '/admin_/$tenantId',
  path: '/admin/$tenantId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/actions': typeof ActionsRoute
  '/admin': typeof AdminRoute
  '/connections': typeof ConnectionsRoute
  '/goals': typeof GoalsRoute
  '/impact': typeof ImpactRoute
  '/management': typeof ManagementRoute
  '/one-on-ones': typeof OneOnOnesRoute
  '/organisation': typeof OrganisationRoute
  '/people': typeof PeopleRoute
  '/performance': typeof PerformanceRoute
  '/report': typeof ReportRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/team': typeof TeamRoute
  '/work': typeof WorkRoute
  '/workforce': typeof WorkforceRoute
  '/admin/$tenantId': typeof AdminTenantIdRoute
  '/auth/callback': typeof AuthCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/actions': typeof ActionsRoute
  '/admin': typeof AdminRoute
  '/connections': typeof ConnectionsRoute
  '/goals': typeof GoalsRoute
  '/impact': typeof ImpactRoute
  '/management': typeof ManagementRoute
  '/one-on-ones': typeof OneOnOnesRoute
  '/organisation': typeof OrganisationRoute
  '/people': typeof PeopleRoute
  '/performance': typeof PerformanceRoute
  '/report': typeof ReportRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/team': typeof TeamRoute
  '/work': typeof WorkRoute
  '/workforce': typeof WorkforceRoute
  '/admin/$tenantId': typeof AdminTenantIdRoute
  '/auth/callback': typeof AuthCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/actions': typeof ActionsRoute
  '/admin': typeof AdminRoute
  '/connections': typeof ConnectionsRoute
  '/goals': typeof GoalsRoute
  '/impact': typeof ImpactRoute
  '/management': typeof ManagementRoute
  '/one-on-ones': typeof OneOnOnesRoute
  '/organisation': typeof OrganisationRoute
  '/people': typeof PeopleRoute
  '/performance': typeof PerformanceRoute
  '/report': typeof ReportRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/team': typeof TeamRoute
  '/work': typeof WorkRoute
  '/workforce': typeof WorkforceRoute
  '/admin_/$tenantId': typeof AdminTenantIdRoute
  '/auth/callback': typeof AuthCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/actions'
    | '/admin'
    | '/connections'
    | '/goals'
    | '/impact'
    | '/management'
    | '/one-on-ones'
    | '/organisation'
    | '/people'
    | '/performance'
    | '/report'
    | '/settings'
    | '/setup'
    | '/team'
    | '/work'
    | '/workforce'
    | '/admin/$tenantId'
    | '/auth/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/actions'
    | '/admin'
    | '/connections'
    | '/goals'
    | '/impact'
    | '/management'
    | '/one-on-ones'
    | '/organisation'
    | '/people'
    | '/performance'
    | '/report'
    | '/settings'
    | '/setup'
    | '/team'
    | '/work'
    | '/workforce'
    | '/admin/$tenantId'
    | '/auth/callback'
  id:
    | '__root__'
    | '/'
    | '/actions'
    | '/admin'
    | '/connections'
    | '/goals'
    | '/impact'
    | '/management'
    | '/one-on-ones'
    | '/organisation'
    | '/people'
    | '/performance'
    | '/report'
    | '/settings'
    | '/setup'
    | '/team'
    | '/work'
    | '/workforce'
    | '/admin_/$tenantId'
    | '/auth/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActionsRoute: typeof ActionsRoute
  AdminRoute: typeof AdminRoute
  ConnectionsRoute: typeof ConnectionsRoute
  GoalsRoute: typeof GoalsRoute
  ImpactRoute: typeof ImpactRoute
  ManagementRoute: typeof ManagementRoute
  OneOnOnesRoute: typeof OneOnOnesRoute
  OrganisationRoute: typeof OrganisationRoute
  PeopleRoute: typeof PeopleRoute
  PerformanceRoute: typeof PerformanceRoute
  ReportRoute: typeof ReportRoute
  SettingsRoute: typeof SettingsRoute
  SetupRoute: typeof SetupRoute
  TeamRoute: typeof TeamRoute
  WorkRoute: typeof WorkRoute
  WorkforceRoute: typeof WorkforceRoute
  AdminTenantIdRoute: typeof AdminTenantIdRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/actions': {
      id: '/actions'
      path: '/actions'
      fullPath: '/actions'
      preLoaderRoute: typeof ActionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connections': {
      id: '/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof ConnectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/goals': {
      id: '/goals'
      path: '/goals'
      fullPath: '/goals'
      preLoaderRoute: typeof GoalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impact': {
      id: '/impact'
      path: '/impact'
      fullPath: '/impact'
      preLoaderRoute: typeof ImpactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/management': {
      id: '/management'
      path: '/management'
      fullPath: '/management'
      preLoaderRoute: typeof ManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-on-ones': {
      id: '/one-on-ones'
      path: '/one-on-ones'
      fullPath: '/one-on-ones'
      preLoaderRoute: typeof OneOnOnesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisation': {
      id: '/organisation'
      path: '/organisation'
      fullPath: '/organisation'
      preLoaderRoute: typeof OrganisationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people': {
      id: '/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof PeopleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/performance': {
      id: '/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof PerformanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report': {
      id: '/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof ReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work': {
      id: '/work'
      path: '/work'
      fullPath: '/work'
      preLoaderRoute: typeof WorkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workforce': {
      id: '/workforce'
      path: '/workforce'
      fullPath: '/workforce'
      preLoaderRoute: typeof WorkforceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/$tenantId': {
      id: '/admin_/$tenantId'
      path: '/admin/$tenantId'
      fullPath: '/admin/$tenantId'
      preLoaderRoute: typeof AdminTenantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActionsRoute: ActionsRoute,
  AdminRoute: AdminRoute,
  ConnectionsRoute: ConnectionsRoute,
  GoalsRoute: GoalsRoute,
  ImpactRoute: ImpactRoute,
  ManagementRoute: ManagementRoute,
  OneOnOnesRoute: OneOnOnesRoute,
  OrganisationRoute: OrganisationRoute,
  PeopleRoute: PeopleRoute,
  PerformanceRoute: PerformanceRoute,
  ReportRoute: ReportRoute,
  SettingsRoute: SettingsRoute,
  SetupRoute: SetupRoute,
  TeamRoute: TeamRoute,
  WorkRoute: WorkRoute,
  WorkforceRoute: WorkforceRoute,
  AdminTenantIdRoute: AdminTenantIdRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
